<template >
<!-- <CompanyPolicy></CompanyPolicy> -->
<div class="col-xxl-12 mb-5">
    <!-- <ECShopAdvisory></ECShopAdvisory> -->
  </div>
  <div v-show="loading"> 
 	<el-skeleton :rows="10" animated />
  </div>	
  <div class="container" v-show="!loading && packagetype !== 'BIBO'"> 
    <div class="card genealogy-chart-card">
      <div class="card-header border-0 pt-5 pb-3">
        <div class="card-title flex-column align-items-start">
          <h3 class="fw-bolder m-0">Genealogy Tree</h3>
          <span class="text-muted fs-7 mt-1" v-if="genealogyRows.length">Viewing {{ usid.toUpperCase() }} · {{ genealogyRows.length }} members</span>
        </div>
        <div class="card-toolbar">
          <div class="genealogy-legend">
            <span class="genealogy-legend-item"><span class="genealogy-legend-dot genealogy-legend-dot--pps"></span>PPS</span>
            <span class="genealogy-legend-item"><span class="genealogy-legend-dot genealogy-legend-dot--active"></span>Active</span>
            <span class="genealogy-legend-item"><span class="genealogy-legend-dot genealogy-legend-dot--vacant"></span>Vacant</span>
          </div>
        </div>
      </div>
      <div class="card-body pt-0 pb-5">
        <div class="genealogy-chart-scroll" ref="chartScroll" :style="chartScrollStyle">
          <div class="genealogy-chart-fit-wrapper" :style="chartFitWrapperStyle">
            <div class="genealogy-chart-fit-inner" :style="chartFitStyle">
              <div id="genealogy-chart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
	
	<div class="card mt-5">
					<div class="card-header cursor-pointer">
					<!--begin::Card title-->
					<div class="card-title m-0">
						<div class="d-flex flex-wrap flex-lg-nowrap align-items-center gap-3 genealogy-toolbar">
							<input
								type="text"
								v-model="searchKey"
								class="form-control form-control-lg form-control-solid genealogy-toolbar-input"
								placeholder="Search by User ID"
								@keydown.enter="search"
							/>
							<button
								@click="search();"
								class="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder flex-shrink-0"
								data-kt-menu-placement="bottom-end"
								data-kt-menu-flip="top-end"
							>
								<span class="svg-icon svg-icon-5 svg-icon-gray-500 me-1">
									<inline-svg src="media/icons/duotone/Text/Filter.svg" />
								</span>
								Search
							</button>
							<button
								@click="gotoUserId('');"
								class="btn btn-sm btn-primary flex-shrink-0"
							>
								Home
							</button>
							<button
								v-if="upOneLevel !== ''"
								@click="gotoUserId(upOneLevel);"
								class="btn btn-sm btn-secondary flex-shrink-0"
							>
								Up
							</button>
						</div>
					</div>
					<!--end::Card title-->

					</div>
					<!--begin::Card header-->
	</div>

  	<GenealogyTable :data="genealogyRows" @navigate="gotoUserId"></GenealogyTable>


	<button type="button" ref="chooseAccountTypeModalButton"  v-show="false"  class="btn btn-primary er fs-6 px-8 py-4"  data-bs-toggle="modal" :data-bs-target="`#kt_modal_choose_account_type`"  >
	Click here
	</button>
	<ChooseAccountTypeModal :key="modalkey" 
							@accountTypeSelected ="accountTypeSelected($event)" 
	></ChooseAccountTypeModal>


	<button type="button" ref="registerNewECButton"  v-show="false"  class="btn btn-primary er fs-6 px-8 py-4"  data-bs-toggle="modal" :data-bs-target="`#kt_register_account_modal_ec`"  >
	Click here
	</button>
	 <RegisterAccountModalEC :key="modalkey" :slotdata="slotdata">
	 </RegisterAccountModalEC>

	 <button type="button" ref="registerAddAccountECButton"  v-show="false"  class="btn btn-primary er fs-6 px-8 py-4"  data-bs-toggle="modal" :data-bs-target="`#kt_add_account_modal_ec`"  >
	Click here
	</button>
	 <RegisterAddAccountModalEC :key="modalkey" :slotdata="slotdata">
	 </RegisterAddAccountModalEC>

	 <button type="button" ref="registerAccountOVIButton"  v-show="false"  class="btn btn-primary er fs-6 px-8 py-4"  data-bs-toggle="modal" :data-bs-target="`#kt_register_account_modal`"  >
	Click here
	</button>
	 <RegisterModal :key="modalkey" :slotdata="slotdata">
	 </RegisterModal>

	 <button type="button" ref="addAccountOVIButton"  v-show="false"  class="btn btn-primary er fs-6 px-8 py-4"  data-bs-toggle="modal" :data-bs-target="`#kt_addovi_account_modal`"  >
	Click here
	</button>
	 <SealProEncode :key="modalkey" :slotdata="slotdata" :sealpro_encode_modal="'kt_addovi_account_modal'" :firstCoverage="firstCoverage"  :allowClose="true" :inputActivationDetail="false" :isAddAccount="true" :allowChangeName="false"></SealProEncode>
  </div>
  
</template>

<script  >
import { loadGoogleCharts } from 'vue-google-charts'

import  GenealogyTable  from '@/views/network/GenealogyTable.vue'
import ChooseAccountTypeModal from '@/views/modals/ChooseAccountTypeModal.vue'
import { genealogyapi} from '@/api/network.api'

import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getCurrentUser, setCurrentUser} from "@/utils/index"
 
import RegisterAccountModalEC from "@/views/auth/RegisterModalEC.vue";
import RegisterAddAccountModalEC from "@/views/auth/RegisterAddAccountModalEC.vue";
import SealProEncode from "@/views/modals/SealProEncode.vue";
import RegisterModal from '../auth/RegisterModal.vue'
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";
// import ECShopAdvisory from "@/views/ECShopAdvisory.vue";

  export default {
    components: {
	  GenealogyTable,
	  ChooseAccountTypeModal,
	  RegisterAccountModalEC,
	  RegisterAddAccountModalEC,
	  SealProEncode,
        RegisterModal,
		// CompanyPolicy,
		// ECShopAdvisory
    },
    data () {
      return {
              // Array will be automatically processed with visualization.arrayToDataTable function
			chartData: null,
			usid: "xxx",
			genealogyRows: [],
			modalkey: 0, 
			takenSlot: [],
			downlines:[],
			searchKey: "",
			upOneLevel: "" ,
			loading: true,
			msg: "Please wait...", 
			ppsBackground: "#47be7d",
			currentAccount: "",
			emptyNodeBackground: "#a1a5b7",
			notPPSBackground: "#3e97ff",
			slotdata: {},

			selectedUPID: "",
			selectedSPID: "",
			selectedPOS: "",

			packagetype: "",
			chartsReady: false,
			_chartSelectListener: null,
			chartScale: 1,
			chartNaturalWidth: 0,
			chartNaturalHeight: 0,
			chartViewportDesktop: true,
			_chartResizeTimer: null,
			currentUsid : ""
      }
    },
    computed: {
      chartFitStyle() {
        if (!this.chartNaturalWidth || !this.chartNaturalHeight) {
          return {};
        }
        if (!this.chartViewportDesktop) {
          return {};
        }
        return {
          transform: 'scale(' + this.chartScale + ')',
          transformOrigin: 'top left',
          width: this.chartNaturalWidth + 'px'
        };
      },
      chartFitWrapperStyle() {
        if (!this.chartNaturalWidth || !this.chartNaturalHeight) {
          return {};
        }
        if (!this.chartViewportDesktop) {
          return {
            width: this.chartNaturalWidth + 'px',
            height: this.chartNaturalHeight + 'px',
            margin: '0 auto'
          };
        }
        return {
          width: (this.chartNaturalWidth * this.chartScale) + 'px',
          height: (this.chartNaturalHeight * this.chartScale) + 'px',
          margin: '0 auto'
        };
      },
      chartScrollStyle() {
        if (!this.chartNaturalHeight) {
          return {};
        }
        if (!this.chartViewportDesktop) {
          return {
            minHeight: this.chartNaturalHeight + 'px'
          };
        }
        return {
          minHeight: (this.chartNaturalHeight * this.chartScale) + 'px'
        };
      }
    },
    methods: {
		  
		  resolveUsid(usid) {
				return (!usid || usid === '') ? 'xxx' : usid;
		  },
		  gotoUserId(u){ 
				this.$router.push({ path: '/networkmenu/genealogy/', query: { usid: u } });
		  },
		  search() {
			  if(this.searchKey === "") return;
			  this.gotoUserId(this.searchKey);
		  },
		  encodeVacant(){
			    setTimeout(() => {    
					const btn = this.$refs.chooseAccountTypeModalButton;
					btn.click();
				}, 100);
		  },
		  registerNewEC(){
			    setTimeout(() => {    
					const btn = this.$refs.registerNewECButton;
					btn.click();
				}, 100);
		  } ,
		  registerAddAccountEC(){
			  setTimeout(() => {    
					const btn = this.$refs.registerAddAccountECButton;
					btn.click();
				}, 100);
		  },
		  registerOVI(){
			  setTimeout(() => {    
					const btn = this.$refs.registerAccountOVIButton;
					btn.click();
				}, 100);
		  },
		  addOVI(){
				setTimeout(() => {    
						const btn = this.$refs.addAccountOVIButton;
						btn.click();
					}, 100);
			},

		 accountTypeSelected(e) {   
			this.slotdata = {
				upid: this.selectedUPID,
				spid: this.selectedSPID,
				position: this.selectedPOS
			} 
			this.modalkey += 1;
			document.getElementById('kt_modal_choose_account_type_closebutton').click();
			if(e === 'regec') { 
				this.registerNewEC();
				return;
			} else if(e === 'addec'){
				this.registerAddAccountEC();
				return;
			} else if(e === 'regovi'){
				this.registerOVI();
				return;
			} else if(e === 'addovi'){
				this.addOVI();
				return;
			}
		  }, 
          drawChart() {
			if (!this.chartData || !window.google || !window.google.visualization) return;

			const chartEl = document.getElementById('genealogy-chart');
			if (!chartEl) return;
			chartEl.innerHTML = '';

            const chart = new google.visualization.OrgChart(chartEl);
            chart.draw(this.chartData, {allowHtml:true, allowCollapse:false, size:'medium' });

			const self = this;
			this.$nextTick(function() {
				self.fitChartToScreen();
				setTimeout(function() {
					self.fitChartToScreen();
				}, 300);
				setTimeout(function() {
					self.fitChartToScreen();
				}, 600);
			});

			if (this._chartSelectListener) {
				google.visualization.events.removeListener(this._chartSelectListener);
			}

    		this._chartSelectListener = google.visualization.events.addListener(chart, 'select', function() {
					let selection = chart.getSelection();
					if(selection[0]!== undefined && selection[0].row !== undefined) {  
						let headno = selection[0].row + 1;
						if(self.downlines[headno] !== undefined)  { 
							self.gotoUserId(self.downlines[headno].usid);
						} else {
							let parent = 0;
							let position = "";
							if(headno % 2 != 0)	 {
								parent = (headno - 1) /2;
								position = "R";
							} else {
								parent = (headno) /2; 
								position = "L";
							}
							if(self.downlines[parent] !== undefined)  {   
								self.modalkey += 1;
								self.encodeVacant(); 
								self.selectedUPID =  self.downlines[parent].usid;
								//self.selectedSPID = self.downlines[1].usid;
								self.selectedSPID = self.currentUsid;
								self.selectedPOS = position; 
							}
						}
					}
			});

          },

		  updateChartViewport() {
				this.chartViewportDesktop = window.innerWidth >= 992;
		  },

		  centerChartScroll() {
				const container = this.$refs.chartScroll;
				if (!container || this.chartViewportDesktop) return;

				const maxScroll = container.scrollWidth - container.clientWidth;
				if (maxScroll > 0) {
					container.scrollLeft = maxScroll / 2;
				}
		  },

		  fitChartToScreen() {
				const container = this.$refs.chartScroll;
				const chartEl = document.getElementById('genealogy-chart');
				if (!container || !chartEl) return;

				this.updateChartViewport();

				const self = this;
				const measureAndFit = function(retryCount) {
					const naturalWidth = chartEl.scrollWidth;
					const naturalHeight = chartEl.scrollHeight;
					if (!naturalWidth || !naturalHeight) {
						if (retryCount < 8) {
							setTimeout(function() {
								measureAndFit(retryCount + 1);
							}, 100);
						}
						return;
					}

					self.chartNaturalWidth = naturalWidth;
					self.chartNaturalHeight = naturalHeight;

					const applyFit = function(fitRetry) {
						const availableWidth = container.clientWidth;
						if (!availableWidth && fitRetry < 8) {
							setTimeout(function() {
								applyFit(fitRetry + 1);
							}, 100);
							return;
						}

						if (self.chartViewportDesktop && availableWidth) {
							const scaleX = availableWidth / naturalWidth;
							self.chartScale = +Math.min(scaleX, 1).toFixed(3);
						} else {
							self.chartScale = 1;
						}

						self.$nextTick(function() {
							self.centerChartScroll();
						});
					};

					requestAnimationFrame(function() {
						applyFit(0);
					});
				};

				this.$nextTick(function() {
					measureAndFit(0);
				});
		  },
		  onChartResize() {
				if (this._chartResizeTimer) {
					clearTimeout(this._chartResizeTimer);
				}
				const self = this;
				this._chartResizeTimer = setTimeout(function() {
					self.fitChartToScreen();
				}, 150);
		  },

		  resetChartData() {
				this.chartData = new google.visualization.DataTable();
				this.chartData.addColumn('string', 'Name');
				this.chartData.addColumn('string', 'Manager');
				this.chartData.addColumn('string', 'ToolTip');
		  },
		  buildPositionBadge(positionNo) {
				return '<span class="genealogy-node-badge">' + positionNo + '</span>';
		  },
		  capitalizeName(name) {
				if (!name) return '';
				return String(name).toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
		  },
		  buildNameBadge(name) {
				if (!name) return '';
				const capitalizedName = this.capitalizeName(name);
				const displayName = capitalizedName.length > 12 ? capitalizedName.substring(0, 12) + '...' : capitalizedName;
				const escapedName = capitalizedName.replace(/"/g, '&quot;');
				return '<span class="genealogy-node-name-spacer"></span><span class="genealogy-node-name-badge" title="' + escapedName + '">' + displayName + '</span>';
		  },
		  isPpsPackageType(desc) {
				return String(desc || '').trim().toUpperCase() === 'PPS';
		  },
		  buildPackageTypeDesc(desc) {
				const ppsClass = this.isPpsPackageType(desc) ? ' genealogy-node-packagetype--pps' : '';
				return '<span class="genealogy-node-packagetype' + ppsClass + '">' + desc + '</span>';
		  },
		  buildAvatarHtml(avatar, headno, usid) {
				return '<div class="genealogy-node-avatar" headno="' + headno + '" id="draggable' + usid + '">' +
					'<img src="' + avatar + '" alt="" class="genealogy-node-avatar-img">' +
					'</div>';
		  },
		  buildFilledNodeContent(positionNo, node) {
				let html = '<div class="genealogy-node-content genealogy-node-content--filled">';
				html += this.buildPositionBadge(positionNo);
				html += this.buildAvatarHtml(node.avatar, positionNo, node.usid);
				html += '<span class="genealogy-node-usid">' + node.usid.toUpperCase() + '</span>';
				if (node.packagetypeDesc) {
					html += this.buildPackageTypeDesc(node.packagetypeDesc);
				}
				html += this.buildNameBadge(node.fullname);
				html += '</div>';
				return html;
		  },
		  buildEmptyNodeContent(positionNo) {
				let html = '<div class="genealogy-node-content genealogy-node-content--vacant">';
				html += this.buildPositionBadge(positionNo);
				html += '<div class="genealogy-node-vacant" headno="' + positionNo + '" id="draggable' + positionNo + '">';
				html += '<span class="genealogy-node-vacant-plus">+</span>';
				html += '<span class="genealogy-node-vacant-text">Vacant</span>';
				html += '</div>';
				html += '</div>';
				return html;
		  },

		async getGenealogy(u){
					this.usid = this.resolveUsid(u);
					this.loading = true;
					const response = await genealogyapi(this.usid); 
					this.loading = false;
					this.upOneLevel = "";
					if(response.data !== undefined  && response.data.genealogyTreeArr !== undefined) {

							this.genealogyRows = response.data.takenslot; 
							this.upOneLevel = response.data.uponelevel;
							
							this.resetChartData();
							this.takenSlot = response.data.takenslot;
							this.downlines = [];
							for(let i = 0; i < this.takenSlot.length; i++) {
								this.downlines[this.takenSlot[i].positionNo] = this.takenSlot[i];
							}

							if (!this.downlines[1]) {
								return;
							}
    						//this.chartData = new google.visualization.DataTable();
							/*for(let i = 0; i < data.length; i++) {
									let avatar = data[i].avatar;
									if(avatar.indexOf("default-avatar.png") > 0 || avatar === "") {
										avatar = "https://images.empoweredconsumerism-static-files.com/avatar/default-avatar.png";
									}
									this.chartData.addRow(
										[ {v: data[i].v + "", f: '<img alt="Logo" src="' + avatar + '" class="h-55px" /> <br/> ' + data[i].v } ,data[i].parent, data[i].tooltip]   
									); 
							} */ 
							let topaccountdiv = this.buildFilledNodeContent(1, this.downlines[1]);
							this.chartData.addRow(
								[ {v: "1", f: topaccountdiv } ,'','']   
							); 


							for(let i = 2; i <= 31; i++) {
								let parent = "";
								if(i > 1) {

									if((i % 2) != 0) {
										parent =  (i - 1) / 2; 
									} else { 
										parent =  i / 2;
									}
								}  
				
								let label = "";
								if(this.downlines[i] !== undefined) {
									label = this.buildFilledNodeContent(i, this.downlines[i]);
								} else {
									label = this.buildEmptyNodeContent(i);
								}



								this.chartData.addRow(
									[ {v: i + "", f: label} , parent + "", '']   
								); 
				

								if(this.downlines[i] !== undefined) {
									if(this.downlines[i].isPPS === 1){  
										this.chartData.setRowProperty(i-1, 'style', 'background: ' + this.ppsBackground + ' !important;');
									}else {
										this.chartData.setRowProperty(i-1, 'style', 'background: ' + this.notPPSBackground + ' !important;');
									} 
								} else {
									this.chartData.setRowProperty(i-1, 'style', 'background: ' + this.emptyNodeBackground + ' !important;');
								}

							}

							this.drawChart();
							 
						}
		}
 	

      },
	mounted(){
		let user = getCurrentUser();
      	this.currentUsid = user.usid;
		this.packagetype = localStorage.getItem("packagetype");
		setCurrentPageTitle("Genealogy");
		this.updateChartViewport();

		loadGoogleCharts('current', { packages: ['orgchart'] }).then(() => {
			this.chartsReady = true;
			this.getGenealogy(this.$route.query.usid);
		});

		window.addEventListener('resize', this.onChartResize);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.onChartResize);
		if (this._chartResizeTimer) {
			clearTimeout(this._chartResizeTimer);
		}
	},
	watch: {
		'$route.query.usid'(usid) {
			if (!this.chartsReady) return;
			this.getGenealogy(usid);
		}
	}


  }

</script>

<style>
  table {
      border-collapse: inherit;
      border-spacing: 0;
  }
  .google-visualization-orgchart-node {
	  border: 2px solid rgba(255, 255, 255, 0.35) !important;
	  background-color: none !important;
	  background:none !important;
	  overflow: visible !important;
	  position: relative !important;
	  padding: 0 !important;
	  cursor: pointer;
	  transition: box-shadow 0.2s ease, filter 0.2s ease;
	  box-shadow: 0 2px 8px rgba(24, 28, 50, 0.12);
  }
  .google-visualization-orgchart-node:hover {
	  box-shadow: 0 6px 16px rgba(24, 28, 50, 0.2) !important;
	  filter: brightness(1.03);
  }
  .genealogy-chart-card {
	  overflow: visible;
  }
  .genealogy-chart-card .card-body {
	  overflow: visible;
  }
  .genealogy-legend {
	  display: flex;
	  flex-wrap: wrap;
	  gap: 0.75rem 1.25rem;
	  align-items: center;
  }
  .genealogy-legend-item {
	  display: inline-flex;
	  align-items: center;
	  gap: 0.4rem;
	  font-size: 0.75rem;
	  font-weight: 600;
	  color: #5e6278;
  }
  .genealogy-legend-dot {
	  width: 10px;
	  height: 10px;
	  border-radius: 50%;
	  flex-shrink: 0;
  }
  .genealogy-legend-dot--pps {
	  background: #47be7d;
  }
  .genealogy-legend-dot--active {
	  background: #3e97ff;
  }
  .genealogy-legend-dot--vacant {
	  background: #a1a5b7;
  }
  .genealogy-node-content {
	  display: inline-block;
	  min-width: 48px;
	  padding-top: 10px;
	  padding-bottom: 0;
  }
  .genealogy-node-avatar {
	  display: block;
	  line-height: 0;
  }
  .genealogy-node-avatar-img {
	  width: 48px;
	  height: 48px;
	  border-radius: 50%;
	  object-fit: cover;
	  border: 2px solid rgba(255, 255, 255, 0.85);
	  box-shadow: 0 2px 6px rgba(24, 28, 50, 0.18);
  }
  .genealogy-node-vacant {
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  justify-content: center;
	  width: 48px;
	  height: 48px;
	  margin: 0 auto;
	  border-radius: 50%;
	  border: 2px dashed rgba(255, 255, 255, 0.55);
	  background: rgba(255, 255, 255, 0.12);
  }
  .genealogy-node-vacant-plus {
	  font-size: 16px;
	  line-height: 1;
	  font-weight: 700;
	  color: rgba(255, 255, 255, 0.9);
  }
  .genealogy-node-vacant-text {
	  font-size: 7px;
	  line-height: 1;
	  font-weight: 600;
	  color: rgba(255, 255, 255, 0.85);
	  margin-top: 2px;
	  text-transform: uppercase;
  }
  .genealogy-node-usid {
	  display: block;
	  font-size: 9px;
	  line-height: 1;
	  margin-top: 4px;
	  margin-bottom: 0;
	  font-weight: 700;
	  letter-spacing: 0.03em;
	  color: #fff;
  }
  .genealogy-node-packagetype {
	  display: inline-block;
	  font-size: 6px;
	  line-height: 1;
	  margin-top: 2px;
	  margin-bottom: 0;
	  padding: 2px 5px;
	  border-radius: 3px;
	  background: rgba(0, 0, 0, 0.22);
	  color: #fff;
	  max-width: 72px;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  white-space: nowrap;
	  font-weight: 600;
  }
  .genealogy-node-packagetype--pps {
	  background: #fff;
	  color: #47be7d;
	  font-weight: 700;
  }
  .genealogy-node-name-spacer {
	  display: block;
	  height: 12px;
	  width: 100%;
  }
  .google-visualization-orgchart-node .genealogy-node-badge {
	  position: absolute;
	  top: 0;
	  left: 50%;
	  transform: translate(-50%, -50%);
	  width: 20px;
	  height: 20px;
	  min-width: 20px;
	  border-radius: 50%;
	  display: inline-flex;
	  align-items: center;
	  justify-content: center;
	  padding: 0;
	  background: #181c32;
	  color: #fff;
	  font-size: 9px;
	  line-height: 1;
	  font-weight: 600;
	  z-index: 1;
	  box-sizing: border-box;
  }
  .google-visualization-orgchart-node .genealogy-node-name-badge {
	  position: absolute;
	  bottom: 0;
	  left: 50%;
	  transform: translate(-50%, 50%);
	  min-width: 20px;
	  max-width: 72px;
	  width: max-content;
	  height: auto;
	  min-height: 16px;
	  border-radius: 4px;
	  display: block;
	  padding: 2px 6px;
	  background: #181c32;
	  color: #fff;
	  font-size: 7px;
	  line-height: 1.2;
	  font-weight: 600;
	  z-index: 1;
	  box-sizing: border-box;
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  text-align: center;
  }

  .genealogy-chart-scroll {
    width: 100%;
    max-width: 100%;
    padding-top: 12px;
  }

  @media (max-width: 991.98px) {
    .genealogy-chart-scroll {
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-x: contain;
      width: 100%;
    }

    .genealogy-chart-fit-wrapper {
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (min-width: 992px) {
    .genealogy-chart-scroll {
      overflow: hidden;
    }
  }

  .genealogy-chart-fit-wrapper {
    position: relative;
    overflow: visible;
  }

  .genealogy-chart-fit-inner {
    display: inline-block;
    transform-origin: top left;
    overflow: visible;
  }

  .genealogy-chart-scroll #genealogy-chart,
  .genealogy-chart-scroll #genealogy-chart table {
    overflow: visible;
    max-width: none;
  }

  .genealogy-toolbar-input {
    width: 100%;
    flex: 1 1 100%;
    min-width: 0;
  }

  @media (min-width: 992px) {
    .genealogy-toolbar {
      white-space: nowrap;
    }

    .genealogy-toolbar-input {
      width: 220px;
      flex: 0 0 auto;
    }
  }
</style>